<div mat-dialog-content class="clean-dialog-content">
    <div class="cleanHeader">
        <h1 class="cleanTouch">{{ 'sla.ui-material.clean.touchscreen-locked.label' | translate }}</h1>
        <h1 class="cleanSecondsStart">{{ timeLeft$ | async }}</h1>
    </div>
    <mat-progress-spinner mode="determinate" [diameter]="200" [value]="((timeLeft$ | async) / data.time) * 100 " color="accent"></mat-progress-spinner>
</div>
